export function MillisToHMS(millis?: number) : string
{
    if (millis === undefined || millis === null)
        return "";

    let seconds = millis / 1000;

    const hours = Math.floor(seconds / 3600 );
    seconds = Math.floor(seconds % 3600);

    const minutes = Math.floor(seconds / 60);

    seconds = Math.floor(seconds % 60);

    let result = "";

    if (hours > 0)
        result += hours + ":";

    result += String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0");
    
    return result;
}

export function SecondsToMinutesAndSeconds(seconds?: number) : string
{
    if (seconds === undefined || seconds === null)
        return "";

    const minutes = Math.floor(seconds / 60);

    seconds = Math.floor(seconds % 60);

    return String(minutes) + ":" + String(seconds).padStart(2, "0") ;
}

export function SecondsToHoursAndMinutes(seconds?: number) : string
{
    if (seconds === undefined || seconds === null)
        return "";

    if (seconds < 60)
        return "< 1 min";

    const hours = Math.floor(seconds / 3600 );
    seconds = Math.floor(seconds % 3600);

    const minutes = Math.floor(seconds / 60);

    let result = "";
    if (hours == 1) result += String(hours) + " hour";
    else if (hours > 0) result += String(hours) + " hours";
    if (hours > 0 && minutes > 0) result += " ";
    if (minutes == 1) result += String(minutes) + " min";
    else if (minutes > 0) result += String(minutes) + " mins";

    return result;
}